import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
import React from 'react';
import AdminRolesFormWrapper from './AdminRolesFormWrapper';

type Props = {
   onClose: (result?: string) => void;
};
const AdminRolesDialog = ({onClose}: Props) => {
   return (
      <Dialog maxWidth="lg" header={DialogTypes.AdminRolesDialog.dialogName} close={onClose}>
         <AdminRolesFormWrapper onClose={onClose} />
      </Dialog>
   );
};

export default AdminRolesDialog;
